import { AuthProvider, type AuthStore, type StaffSession } from '@pa/staff'
import { ToastProvider } from '@pa/ui'
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import type { ReactNode } from 'react'

export function Providers({
  queryClient,
  auth,
  session,
  children,
}: {
  queryClient: QueryClient
  auth: AuthStore
  session: StaffSession
  children: ReactNode
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider store={auth} session={session}>
        <ToastProvider>{children}</ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
